export const ZOOM_DEFAULT = 11;
export const ZOOM_FOCUSED = 19;
export const ZOOM_MAX = 22;
export const ZOOM_MIN = 10.5;
